<template>
  <b-modal
    id="mc-modal-accept"
    centered
    scrollable
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    size="md"
    :title="$t('deliveryRequest.modal.acceptFleetTask.title')"
  >
    <div class="mc-modal-accept card-body">
      <p class="mc-modal-accept__text mb-0">
        <span v-if="!isFromList">
          <span v-html="$t('deliveryRequest.modal.acceptFleetTask.single', { companyName })"></span>
        </span>
        <span v-else>
          {{ $t('deliveryRequest.modal.acceptFleetTask.multiple', { total }) }}
        </span>
      </p>
      <p v-if="hasTmsUserGroupAccess" class="mb-0">
        {{ $t('deliveryRequest.modal.acceptFleetTask.userGroupHint') }}
      </p>
    </div>

    <FormulateForm
      v-if="hasTmsUserGroupAccess"
      v-model="formValues"
      name="accept-form"
      class="mb-0"
      @validation="handleValidation"
    >
      <FormulateInput
        name="userGroup"
        :placeholder="`${$t('global.form.select')} ${$t('master.form.employee.userGroup')}`"
        :multiple="false"
        type="value-help-v2"
        trackBy="id"
        :displayedBy="'name'"
        :listGetter="resourcefulQuery.userGroups"
        :tableFields="userGroupTableFields"
        :fullObject="fullObject.userGroup"
        validation="required"
        :validation-messages="{
          required: $t('master.form.employee.userGroupRequired'),
        }"
        :help="true"
      />
    </FormulateForm>

    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0 gap-2">
        <McButton :disabled="isLoading" variant="secondary" :text="$t('global.no')" @click="cancel" />
        <McButton :disabled="isLoading" :text="$t('deliveryRequest.modal.acceptFleetTask.confirm')" @click="handleSubmit" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'
import McButton from '@/components/McButton'

import { GET_USER_GROUP } from '@/services/api/setting/user/userGroup'

export default {
  components: {
    McButton,
  },
  mixins: [Helper],
  props: {
    showResponse: {
      type: Object,
      default: () => {},
    },
    isFromList: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  emits: ['transition'],
  data() {
    return {
      isLoading: false,
      customerName: '',
      formValues: {},
      fullObject: {
        userGroup: {},
      },
      errorObj: {},
    }
  },
  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    companyName() {
      return this.showResponse?.parent_company?.name
    },
    hasTmsUserGroupAccess() {
      return (
        this.hasAccessAll([
          'tms-user-group:create',
          'tms-user-group:delete',
          'tms-user-group:read',
          'tms-user-group:update',
        ]) &&
        this.isSuperUser()
      )
    },
    resourcefulQuery() {
      return {
        userGroups: async (opts) => {
          let result = {}
          const filter = {
            pagination: {
              page: opts?.page,
              show: opts?.limit,
            },
            search: opts?.search,
          }

          const res = await this.$apollo.query({
            query: GET_USER_GROUP,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filter,
              },
            },
          })

          const ugroups = res.data.ugroups.ugroups

          result = {
            metadata: {
              total_count: ugroups.pagination.total,
              page: ugroups.pagination.page,
            },
            data: {
              paginated_result: ugroups.data,
            },
          }

          return result
        },
      }
    },
    userGroupTableFields() {
      return [
        {
          key: 'name',
          label: this.$t('master.form.employee.userGroup'),
          isSortable: false,
          isRedirectable: true,
        },
        {
          label: this.$t('delivery.fields.vehicleGroup'),
          key: 'vgroups',
          isSortable: false,
          formatter: (value) => {
            return value?.length != null
              ? (value.length === 0 ? this.$t('delivery.fields.allVehicleGroup') : value.length)
              : '-'
          },
        },
      ]
    },
  },
  methods: {
    handleValidation(error) {
      this.errorObj = error
    },
    handleSubmit() {
      if (this.hasTmsUserGroupAccess) {
        this.$formulate.submit('accept-form')

        if (this.errorObj.hasErrors) return
      }

      this.isLoading = true

      const data = {
        status: 'ACCEPTED',
        fields: {}
      }

      if (this.hasTmsUserGroupAccess) {
        data.fields.user_group_id = Number(this.formValues.userGroup)
      }

      this.$emit('transition', 'ACCEPT', data)
      this.isLoading = false
    },
  },
}
</script>
